import { ContentService } from '@blk/cwp-ng-framework';

import { Formatter } from './formatter.interface';

export class DefaultFormatter implements Formatter {
	public static readonly instance = new DefaultFormatter();
	public format(value: any, contentSvc?: ContentService): string {
		if (contentSvc && value) {
			return contentSvc.get(value, value);
		}
		return value;
	}
}
